import { useEffect, useState } from 'react';
import { api } from '../api';
import type { FunnelConfig } from '../types';

export function FunnelEditor({ tenantId }: { tenantId?: string }) {
  const [funnel, setFunnel] = useState<FunnelConfig | null>(null);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.getFunnel(tenantId).then(setFunnel).catch((e) => setError(String(e)));
  }, [tenantId]);

  if (error) return <div className="empty">שגיאה: {error}</div>;
  if (!funnel) return <div className="empty">טוען…</div>;

  const flags = funnel.stepFlags ?? {};

  function setFlag(name: 'carConfirmation' | 'gender' | 'city', value: boolean) {
    setFunnel((f) => (f ? { ...f, stepFlags: { ...f.stepFlags, [name]: value } } : f));
    setSaved(false);
  }

  async function save() {
    if (!funnel) return;
    await api.saveFunnel(funnel, tenantId);
    setSaved(true);
  }

  return (
    <div className="editor">
      <h2>עריכת בוט</h2>
      <p className="page-subtitle" style={{ marginTop: 0 }}>
        הגדרות מבניות של הבוט. נוסח השאלות ובנק התגובות נערכים במסך "מאגר ידע".
      </p>

      <div className="card">
        <h3>שלבים אופציונליים</h3>
        {(['carConfirmation', 'gender', 'city'] as const).map((name) => (
          <label key={name} style={{ display: 'block', marginBottom: 8 }}>
            <input
              type="checkbox"
              checked={Boolean(flags[name])}
              onChange={(e) => setFlag(name, e.target.checked)}
            />{' '}
            {name}
          </label>
        ))}
      </div>

      <div className="card">
        <div className="field">
          <label>שם הסוכנות (מוצג בפתיח)</label>
          <input
            value={funnel.agencyDisplayName ?? ''}
            onChange={(e) => {
              setFunnel((f) => (f ? { ...f, agencyDisplayName: e.target.value } : f));
              setSaved(false);
            }}
          />
        </div>
      </div>

      <div className="row-actions">
        <button className="btn" onClick={save}>
          שמור שינויים
        </button>
        {saved && <span className="badge">נשמר ✓</span>}
      </div>
    </div>
  );
}
